/* eslint-disable class-methods-use-this */
import axios from 'axios';
import { stringify } from 'querystring';

import {
  CmsPageContentType,
  GetHardwareResponseType,
  SelectedHardwareType,
} from '@/types/fitting-hardware';

import { renderCmsContent } from '@/utils/content';
import mockFittingHardwareResult from './mockFittingHardwareResult.json';

class ApiService {
  private readonly serviceUrl: string;

  constructor(serviceUrl: string) {
    this.serviceUrl = serviceUrl;
  }

  async getPageValue() {
    return axios
      .get(`${this.serviceUrl}/rest/hardware-rent/page`)
      .then((result) => {
        const cmsContent: CmsPageContentType = {};
        Object.entries(result.data.cmsContent).forEach(([key, value]) => {
          cmsContent[key] = renderCmsContent((value as any));
        });
        return {
          cmsContent,
        };
      })
      .catch(() => undefined);
  }

  async getCmsSnippetSet(setName: string) {
    const cmsContent: CmsPageContentType = {};
    return axios
      .get(`${this.serviceUrl}/rest/cms/snippets?setName=${setName}`)
      .then((result) => {
        Object.entries(result.data).forEach(([key, value]) => {
          cmsContent[key] = renderCmsContent((value as any));
        });

        return cmsContent;
      })
      .catch(() => undefined);
  }

  async getHardwareOptions(
    tariffOfferName: string,
    targetGroup: string,
    shopContext: string,
    selectedConnectionType: string | null,
  ): Promise<GetHardwareResponseType> {
    const queryString = stringify({
      tariffOfferName,
      targetGroup,
      shopContext,
      selectedConnectionType,
    });
    return process.env.mock ? new Promise<GetHardwareResponseType>((resolve) => {
      resolve({
        hardware: mockFittingHardwareResult.hardware,
        hardwareSelectionHint: mockFittingHardwareResult.hardwareSelectionHint,
        hardwareSelectionEnabled: mockFittingHardwareResult.hardwareSelectionEnabled,
        accessType: mockFittingHardwareResult.accessType,
      });
    }) : (
      axios.get(`${this.serviceUrl}/rest/fitting-hardware?${queryString}`)
        .then((response) => response.data)
        .catch(() => ({
          hardware: [],
        }))
    );
  }

  async selectHardwareOption({
    tariffOfferName,
    shopContext,
    articleId,
    selected,
    ownHardware,
  }: SelectedHardwareType): Promise<number> {

    const data = {
      tariffOfferName,
      shopContext,
      articleId,
      selected,
      ownHardware,
    };
    return axios.post(
      `${this.serviceUrl}/rest/hardware`,
      data,
    ).then((response) => (process.env.mock ? 200 : response.status));
  }
}

export default ApiService;
